import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Download, Printer, FileSpreadsheet, FileText } from 'lucide-react';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from './ui/dropdown-menu';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Server-built ledger export. Current View = the ids the Invoices page is showing (same filters, same order).
export const InvoiceLedgerExport = ({ currentIds, sort, viewLabel }) => {
  const [busy, setBusy] = useState(false);
  const run = async (format, scope) => {
    const win = format === 'print' ? window.open('', '_blank') : null;
    setBusy(true);
    try {
      const body = { format, sort, view_label: viewLabel, ids: scope === 'current' ? currentIds : null };
      const { data, headers } = await axios.post(`${API}/invoices/export`, body, { withCredentials: true, responseType: 'blob' });
      const url = URL.createObjectURL(data);
      if (win) { win.location.href = url; } else {
        const name = (headers['content-disposition'] || '').match(/filename="([^"]+)"/)?.[1] || `invoice-ledger.${format}`;
        const a = document.createElement('a'); a.href = url; a.download = name; document.body.appendChild(a); a.click(); a.remove();
        setTimeout(() => URL.revokeObjectURL(url), 5000);
      }
    } catch (e) { if (win) win.close(); toast.error('Export failed'); }
    setBusy(false);
  };
  const items = (scope) => [
    ['csv', 'Export CSV', FileText], ['xlsx', 'Download Excel', FileSpreadsheet], ['print', 'Print', Printer],
  ].map(([f, l, Icon]) => (
    <DropdownMenuItem key={`${scope}-${f}`} data-testid={`inv-ledger-${scope}-${f}`} onClick={() => run(f, scope)} className="text-white text-xs cursor-pointer">
      <Icon className="w-3.5 h-3.5 mr-2" />{l}
    </DropdownMenuItem>
  ));
  return (
    <DropdownMenu>
      <DropdownMenuTrigger data-testid="inv-ledger-export-btn" disabled={busy}
        className="inline-flex items-center gap-2 rounded-md border border-[#3f3f3f] px-3 py-2 text-sm text-white hover:border-[#D4AF37] disabled:opacity-50">
        <Download className="w-4 h-4" /> {busy ? 'Exporting…' : 'Export / Print'}
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-[#141414] border-[#262626] w-60">
        <DropdownMenuLabel className="text-[10px] uppercase tracking-wider text-[#737373]">Current View ({currentIds.length})</DropdownMenuLabel>
        {items('current')}
        <DropdownMenuSeparator className="bg-[#262626]" />
        <DropdownMenuLabel className="text-[10px] uppercase tracking-wider text-[#737373]">All Invoices</DropdownMenuLabel>
        {items('all')}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default InvoiceLedgerExport;
